import { Fragment, useContext } from "react";
import { SettingsContext, ShopContext } from "../App";
import currencyFormat from "./functions/functions";
import "../css/Variants.css";
import CloseButton from "./CloseButton";
import Allergens from "./Allergens";
import Label from "./Label";
import Tags from "./Tags";
import { getDefaultProductConfiguration, hasProductCustomizations } from "./productConfiguration";
import { PiPencilSimple } from "react-icons/pi";
import PlusIcon from "../icons/PlusIcon";

function ProductSheet({ product }) {
	const { settings, setProductSheet, setSelectedProduct, handleAddProduct, lang } =
		useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const hasCustomizations = hasProductCustomizations(product);
	const allowOptionalVariantsDirectCartAdd =
		settings?.menu_api?.allow_optional_variants_direct_cart_add == 1;

	const openEditor = () => {
		setProductSheet(false);
		setSelectedProduct(product);
	};

	const handleQuickAdd = () => {
		if (hasCustomizations) {
			if (!allowOptionalVariantsDirectCartAdd) {
				openEditor();
				return;
			}

			const configuration = getDefaultProductConfiguration(product);
			if (configuration.hasRequiredSelections) {
				openEditor();
				return;
			}

			handleAddProduct({
				...product,
				qty: 1,
				variants: configuration.variants,
				products: configuration.products,
				notes: configuration.notes,
			});
			return;
		}

		handleAddProduct({
			...product,
			qty: 1,
			variants: [],
			products: [],
			notes: "",
		});
	};

	return (
		<div id="product-sheet" className="popup">
			<div className="content">
				<div className="popup-header">
					<CloseButton onClick={() => setProductSheet(false)} />
					<h3 className="mb-0">{product.name}</h3>
					{product.discounted ? (
						<>
							<s>{currencyFormat(product.price, false, shop.currency)}</s>
							{" - " + currencyFormat(product.discount.price, false, shop.currency)}
						</>
					) : (
						currencyFormat(product.price, false, shop.currency)
					)}
				</div>
				<div className="popup-scroll">
					<div className="popup-content">
						<div className="info row">
							{product.img && (
								<div className="img col-sm-4 mb-3">
									<img src={product.img} />
								</div>
							)}
							<Tags product={product} className="mb-2" />
							{product.description && (
								<div className="description col">
									{product.description && (
										<div
											dangerouslySetInnerHTML={{
												__html: product.description,
											}}
										/>
									)}
								</div>
							)}
						</div>
						<div className="row">
							{product.ingredients.length > 0 && (
								<div className="col-sm mb-3">
									<div
										className="subtitle"
										style={{
											backgroundColor: settings.selfordering.color1,
											color: settings.selfordering.color2,
										}}
									>
										<Label number={40} />
									</div>
									<div className="ingredients">
										{product.ingredients.map((ingredient, i) => (
											<Fragment key={i}>
												{ingredient.name}
												{i < product.ingredients.length - 1 && ", "}
											</Fragment>
										))}
									</div>
								</div>
							)}
							{product.allergens.length > 0 && (
								<div className="col-sm mb-3">
									<div
										className="subtitle"
										style={{
											backgroundColor: settings.selfordering.color1,
											color: settings.selfordering.color2,
										}}
									>
										<Label number={41} />
									</div>
									<div className="allergens">
										<Allergens
											allergens={product.allergens}
											color="#000"
											backgroundColor="#ccc"
											lang={lang}
										/>
									</div>
								</div>
							)}
						</div>
						<div className="buttons">
							{product.disabled != 1 &&
								hasCustomizations &&
								allowOptionalVariantsDirectCartAdd && (
								<button className="button button-circle button-edit" onClick={openEditor}>
									<PiPencilSimple />
								</button>
							)}
							{product.disabled != 1 && (
								<button
									className="button button-circle button-add"
									onClick={handleQuickAdd}
									style={{
										backgroundColor: settings.selfordering.color1,
										color: settings.selfordering.color2,
									}}
								>
									<PlusIcon />
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ProductSheet;
